import { Component, Input } from '@angular/core';
import { SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';

@Component({
    selector: 'odq-surplus-info',
    templateUrl: './surplus-info.component.html',
    styleUrls: ['./surplus-info.component.scss', '../styles/subscription-forms.css'],
    standalone: false
})
export class SurplusInfoComponent {
  @Input() model: SubscriptionFormViewModel;
}